import { FC } from "react";
import { CompanyBody, SiteItem } from "@vviinn/user-managment-client-ts";

import { NavLink, useParams } from "react-router";
import { useAppSelector } from "../../../store";
import { RouteDependency } from "../../../routes/utils";
import { MenuItemProps } from "./menuItems";
import { MENU_ICON_STYLE } from "../styles";

export const ITEM_DEFAULT_STYLES =
  "group flex w-full items-center rounded-md px-2 py-2 font-medium text-stone-600 hover:bg-stone-100 hover:text-stone-900 dark:text-stone-300 dark:hover:bg-stone-900 dark:hover:text-stone-300";

export const MenuItem: FC<React.PropsWithChildren<MenuItemProps>> = ({
  item,
  closeMenuMobile,
  isMobile,
}): JSX.Element => {
  const { companyId, siteId } = useParams();
  const companies = useAppSelector((state) => state.companies.companies);
  const selectedCompanyId = useAppSelector(
    (state) => state.company.company?.id,
  );
  const sites = useAppSelector((state) => state.sites.sites);
  const selectedSiteId = useAppSelector((state) => state.site?.id);

  const getActualCompanyId = (): CompanyBody["id"] => {
    if (companyId) return companyId;
    return selectedCompanyId ?? companies[0]?.id;
  };

  const getActualSiteId = (): SiteItem["id"] | undefined =>
    (siteId ? parseInt(siteId) : undefined) ?? selectedSiteId ?? sites[0]?.id;

  const hrefTransformFunctions: Map<RouteDependency, (arg: string) => string> =
    new Map([
      ["company", (href) => `company/${getActualCompanyId()}/${href}`],
      [
        "site",
        (href) => {
          const actualSiteId = getActualSiteId();
          if (actualSiteId) {
            return `company/${getActualCompanyId()}/site/${getActualSiteId()}/${href}`;
          }
          if (!actualSiteId && href === "dashboard") {
            return `company/${getActualCompanyId()}/site/no-id/${href}`;
          }
          if (!actualSiteId && href === "") {
            return `company/${getActualCompanyId()}/sites`;
          }
          return href === "campaigns" || href === "products"
            ? `${href}/no-sites`
            : "#";
        },
      ],
      [
        "campaigns",
        (href) => {
          const actualSiteId = getActualSiteId();
          if (actualSiteId) {
            const base = `company/${getActualCompanyId()}/site/${getActualSiteId()}/campaigns`;
            return href ? `${base}/${href}` : base;
          }
          return href === "campaigns" || href === "products"
            ? `${href}/no-sites`
            : "#";
        },
      ],
    ]);

  const transformHref = (
    item.dependency
      ? hrefTransformFunctions.get(item.dependency)
      : () => item.href
  ) as (arg?: string) => string;

  return (
    <NavLink
      end
      to={`../${transformHref(item.href)}`}
      key={item.name}
      id={`${item.name}${isMobile ? "Mobile" : ""}`}
      onClick={() => {
        if (closeMenuMobile) {
          closeMenuMobile();
        }
      }}
      className={({ isActive }) =>
        isActive
          ? `${ITEM_DEFAULT_STYLES}
             bg-stone-100 text-stone-900 dark:bg-stone-900 dark:text-stone-50`
          : ITEM_DEFAULT_STYLES
      }
    >
      <item.icon className={MENU_ICON_STYLE} />
      {item.name}
    </NavLink>
  );
};
